import { CopyableText } from '@acme/foundation';
import type { SupportContact } from './model';

export interface ContactCardProps {
  contact: SupportContact;
  rulesLink?: string;
  onRulesClick?: () => void;
}

export const ContactCard: React.FC<ContactCardProps> = ({
  contact,
  rulesLink = '/rules',
  onRulesClick,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg size-full">
      <div className="flex flex-col gap-6 p-6">
        <div className="flex gap-6 items-start w-full">
          <h2 className="font-semibold text-xl text-gray-900">Контакты</h2>
        </div>

        <div className="flex gap-3 items-center pb-3 border-b border-gray-200 w-full">
          <div className="flex flex-col gap-1 flex-1 min-w-0">
            <p className="text-sm text-gray-500">Эл. почта</p>
            <CopyableText value={contact.email} />
          </div>

          <div className="flex flex-col gap-1 flex-1 min-w-0">
            <p className="text-sm text-gray-500">Телефон</p>
            <CopyableText value={contact.phone} />
          </div>

          <div className="flex flex-col gap-1 flex-1 min-w-0">
            <p className="text-sm text-gray-500">Рабочее время поддержки</p>
            <div className="flex gap-2.5 items-center rounded-lg w-full">
              <p className="font-medium text-base text-gray-900">
                {contact.workingHours}
              </p>
            </div>
          </div>
        </div>

        {onRulesClick ? (
          <button
            onClick={onRulesClick}
            className="text-base text-primary-600 hover:text-primary-700 text-left transition-colors"
          >
            Правила использования платформы
          </button>
        ) : (
          <a
            href={rulesLink}
            className="text-base text-primary-600 hover:text-primary-700 transition-colors"
          >
            Правила использования платформы
          </a>
        )}
      </div>
    </div>
  );
};
